/// <amd-module name="Core/Medius.Core.Web/Scripts/components/grid/isActiveCell"/>
import * as React from "react";
import { ChangeEvent } from "react";
import { GridCellProps, GridCustomCellProps, GridCustomFilterCellProps, GridFilterCellProps } from "@progress/kendo-react-grid";
import { BoolToggle, BoolToggleElement } from "Core/Medius.Core.Web/Scripts/shared/components/boolToggle";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";
import { HeaderThElement } from "@progress/kendo-react-data-tools";


export const IsActiveCell = ({ tdProps, dataItem }: GridCustomCellProps) => (
    <td {...tdProps}>
        {dataItem.IsActive ? translate("#Core/yes") : translate("#Core/no")}
</td>
);

export const IsActiveFilterCell = ({ thProps, onChange }: GridCustomFilterCellProps) => {
    const onToggle = (syntheticEvent: ChangeEvent<BoolToggleElement>) => {
        const value = syntheticEvent.target.value;
        onChange({
            value,
            operator: value !== null ? "eq" : "",
            syntheticEvent
        });
    };

    return <HeaderThElement columnId={thProps?.columnId ?? ""} {...thProps}>
        <BoolToggle
            onToggle={onToggle}
            trueLabel={translate("#Core/yes")}
            falseLabel={translate("#Core/no")} />
    </HeaderThElement>;
};

/**
 * @deprecated This cell should be only used with deprecated cell property of KendoReact, it will be removed when migration to version 11 is finished
 * See: https://medius.atlassian.net/wiki/spaces/~15501514/pages/5315297297/KendoReact+upgrade+to+version+11
 */
export const LegacyIsActiveCell = ({ dataItem }: GridCellProps) => (
    <td>
        {dataItem.isActive ? translate("#Core/yes") : translate("#Core/no")}
    </td>
);

/**
 * @deprecated This cell should be only used with deprecated filterCell property of KendoReact, it will be removed when migration to version 11 is finished
 * See: https://medius.atlassian.net/wiki/spaces/~15501514/pages/5315297297/KendoReact+upgrade+to+version+11
 */
export const LegacyIsActiveFilterCell = ({ onChange }: GridFilterCellProps) => {
    const onToggle = (syntheticEvent: ChangeEvent<BoolToggleElement>) => {
        const value = syntheticEvent.target.value;
        onChange({
            value,
            operator: value !== null ? "eq" : "",
            syntheticEvent
        });
    };

    return <BoolToggle
        onToggle={onToggle}
        trueLabel={translate("#Core/yes")}
        falseLabel={translate("#Core/no")} />;
};